/**
 * Dossiê de Projeto e Manual de Colaboração: Ecossistema Golden Sisters
 * COPIAR ARQUIVO → src/pages/PrintReceiptPage.js
 * Versão: 1.0.0 (Criação)
 * Data: 20/09/2025
 * Responsável pela Alteração: Gemini (conforme plano de impacto)
 *
 * Resumo:
 * - Página dedicada para renderizar um cupom de venda e acionar a impressão.
 * - Busca os dados da venda no Firestore com base no ID da URL.
 * - Aciona window.print() automaticamente após renderizar o cupom.
 * - Exibe status de carregamento e erro.
 */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import Receipt from '../components/pos/Receipt';
import { Loader2 } from 'lucide-react';

const PrintReceiptPage = () => {
    const { saleId } = useParams();
    const [saleData, setSaleData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Efeito para buscar os dados da venda
    useEffect(() => {
        if (!saleId) {
            setError("ID da venda não fornecido.");
            setLoading(false);
            return;
        }

        const fetchSaleData = async () => {
            try {
                const saleRef = doc(db, 'sales', saleId);
                const docSnap = await getDoc(saleRef);

                if (docSnap.exists()) {
                    setSaleData(docSnap.data());
                } else {
                    setError(`Venda com ID "${saleId}" não encontrada.`);
                }
            } catch (err) {
                console.error("Erro ao buscar dados da venda:", err);
                setError("Ocorreu um erro ao buscar os dados da venda.");
            } finally {
                setLoading(false);
            }
        };

        fetchSaleData();
    }, [saleId]);

    // Efeito para acionar a impressão quando os dados estiverem prontos
    useEffect(() => {
        if (saleData && !loading && !error) {
            // Pequena pausa para garantir que o DOM está 100% renderizado
            const timer = setTimeout(() => {
                window.print();
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [saleData, loading, error]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif' }}>
                <Loader2 className="animate-spin" style={{ marginRight: '10px' }} />
                Carregando cupom...
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif', color: 'red' }}>
                {error}
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', paddingTop: '20px', backgroundColor: '#f5f5f5' }}>
            <Receipt data={saleData} />
        </div>
    );
};

export default PrintReceiptPage;